import axios from 'axios';

import environment from 'environment';
import { getSessionToken } from 'util/parseSelectors';
import request from 'util/superagent';
import { getSessionTokenHeader } from '../util/util';

export const getRecommendedProducts = async (params) => {
  const requestParams = {
    businessId: params.businessId,
    conversationId: params.conversationId,
    subject: params.subject,
    message: params.message,
    customerId: params.customerId,
    shopNames: params.shopNames,
    customerEmail: params.customerEmail,
    brand: params.brand,
    expertId: params.expertId,
  };
  const sessionTokenHeader = await getSessionTokenHeader();
  const requestConfig = { headers: sessionTokenHeader };

  const response = await axios.post(environment.services.recommendProductsUrl, requestParams, requestConfig);

  return response;
};

export const updatePreviouslyRecommendedProducts = async (product, conversationId) => {
  const sessionToken = getSessionToken();
  const response = await request
    .post(`${environment.app.serverApiUrl}/v1/commerce/update-previously-recommended-products`)
    .set('Accept', 'application/json')
    .set('x-session-token', sessionToken)
    .send({ product, conversationId });

  return response.body;
};
